// extracted by mini-css-extract-plugin
export default {"EditorArea":"EditorArea_EditorArea__97hmS","canvasContainer":"EditorArea_canvasContainer__9DSVO","hidden":"EditorArea_hidden__AH2B2"};